import { OPEN_TASK_STATUSES } from './cardStatus';
import { formatDateTime } from './formatFieldValue';

// A visit request and the visit it is scheduled into are two tasks on the server (the visit
// points at its request through parent_task_id, see CardTasks::ScheduleVisitService) and one
// thing on the dashboard: the request carries its current visit in `visit`.
export const VISIT_REQUEST_KEY = 'visit';
export const SCHEDULED_VISIT_KEY = 'scheduled_visit';

// The task a row shows and works: the visit once there is one, else the task itself.
export const shownTask = task => task.visit || task;

export const isVisitRequest = task => task.system_key === VISIT_REQUEST_KEY;

export const isScheduledVisit = task => task.system_key === SCHEDULED_VISIT_KEY;

// A visit is scheduled, then done or canceled; it is never started (CardTaskType#startable?).
export const isStartable = task => !isScheduledVisit(task);

export const canScheduleVisit = task =>
  isVisitRequest(task) &&
  !task.visit &&
  OPEN_TASK_STATUSES.includes(task.status);

// A visit shows inside its request, so it is not listed again on its own.
export const topLevelTasks = tasks => {
  const ids = new Set(tasks.map(task => task.id));
  return tasks.filter(task => !ids.has(task.parent_task_id));
};

// The dates the customer offered, as datetime-local values. Form datetimes are naive wall-clock
// values tagged UTC (see formatFieldValue), so their digits are read as they are.
export const offeredVisitDates = task =>
  (task.fields || [])
    .filter(field => field.type === 'datetime' && task.data?.[field.key])
    .map(field => ({
      key: field.key,
      value: formatDateTime(task.data[field.key], "yyyy-MM-dd'T'HH:mm"),
    }));
